import React, { FC, useState } from 'react';
import Modal from 'styled-react-modal';
import moment from 'moment-timezone';

import { useTranslations } from '@lang';
import { Button } from '@common/components/Button';
import { BACKEND_URL, getPreviewId } from './services';
import { PreviewButtons, StyledIframe } from './Preview.styles';
import { previewTypeEvoucher, previewTypeOverprint } from './constants';
import { useLabels } from '@features/Menu/useLabels';
import { FulfilableBasketItemType } from '@features/AddedToBasket/Fulfilable/FulfilableAddedToBasket.types';
import { Personalization } from 'shared-types';

export type PreviewProps = {
  printablePersonalization?: Personalization;
  propertyId?: number;
  itemId?: number;
  optionId?: number;
  hasDefaultEVoucher: boolean;
  hasDefaultOverprint: boolean;
  hasDefaultETicket: boolean;
  hasDefaultTicketOverprint: boolean;
  type: FulfilableBasketItemType;
  index: number;
};

export const Preview: FC<PreviewProps> = ({
  printablePersonalization,
  propertyId,
  itemId,
  optionId,
  hasDefaultEVoucher,
  hasDefaultOverprint,
  hasDefaultETicket,
  hasDefaultTicketOverprint,
  type,
}) => {
  const { t } = useTranslations();
  const labels = useLabels();
  const [previewToken, setPreviewToken] = useState('');
  const [showPreview, setShowPreview] = useState(false);
  const voucherSingular =
    labels?.vouchers?.charAt(labels?.vouchers.length - 1) === 's'
      ? labels.vouchers.slice(0, -1)
      : labels.vouchers;

  const buttonTextEvoucher = {
    voucher: t('personalization.previewEVoucher', {
      voucherCustomLabel: voucherSingular?.toLowerCase() ?? 'voucher',
    }),
    event: t('personalization.previewETicket'),
  };

  const buttonTextOverprint = {
    voucher: t('personalization.previewPostalVoucher', {
      voucherCustomLabel: voucherSingular ?? 'Voucher',
    }),
    event: t('personalization.previewPostalTicket'),
  };

  const getPreview = (previewType) => {
    getPreviewId(
      {
        printablePersonalization,
        printableDateFrom: printablePersonalization?.validFrom
          ? moment(printablePersonalization?.validFrom).format('YYYY-MM-DD')
          : moment().format('YYYY-MM-DD'),
        [type]: {
          id: itemId,
          option: optionId,
        },
      },
      setShowPreview,
      setPreviewToken,
      previewType,
      propertyId
    );
  };

  return (
    <>
      <PreviewButtons>
        {((type === 'voucher' && hasDefaultEVoucher) ||
          (type === 'event' && hasDefaultETicket)) && (
          <Button onClick={() => getPreview(previewTypeEvoucher)} type="button">
            {buttonTextEvoucher[type]}
          </Button>
        )}
        {((type === 'voucher' && hasDefaultOverprint) ||
          (type === 'event' && hasDefaultTicketOverprint)) && (
          <Button onClick={() => getPreview(previewTypeOverprint)} type="button">
            {buttonTextOverprint[type]}
          </Button>
        )}
        <Modal
          width={700}
          isOpen={showPreview}
          onBackgroundClick={() => setShowPreview(false)}
          onEscapeKeydown={() => setShowPreview(false)}
        >
          <StyledIframe
            title="preview"
            src={`${BACKEND_URL}/${propertyId}/stationery/print_preview/${previewToken}/pdf`}
          />
        </Modal>
      </PreviewButtons>
    </>
  );
};
